var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('destination-marker',{ref:"destinationMarker"}),_c('spot-marker',{ref:"spotMarker"}),_c('google-place-marker'),_c('location-marker'),_c('my-spot-marker')],1)}
var staticRenderFns = []

export { render, staticRenderFns }